import React from "react";
import "./DropDown.scss";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const useStyles = makeStyles((theme) => ({
  select: {
    width: "max-content",
    paddingRight: "10px",
  },
  img: {
    height: 30,
    width: 30,
    marginBottom: -8,
    display: "inline-block",
    marginRight: 8,
    overflow: "hidden",
    borderRadius: "50%",
  },
  text: {
    display: "inline-block",
    margin: 0,
    marginTop: 8,
  },
  item: {
    paddingTop: 10,
    paddingBottom: 10,
  },
}));

const DropDown = ({ text, value, onChange, required, data, name, colors }) => {
  const classes = useStyles();

  return (
    <div className="DropDown">
      <span className="text">{text}</span>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        onChange={onChange ? (e) => onChange(e) : null}
        className={classes.select}
        required={required}
        name={name}
      >
        {data &&
          data.map((option, i) => (
            <MenuItem
              key={i}
              className={classes.item}
              value={colors ? option : option.value}
            >
              <p className={classes.text}>{colors ? option : option.text}</p>
            </MenuItem>
          ))}
      </Select>
    </div>
  );
};

export default DropDown;
